<div class="mt-3  mb-3 form-inline">
  <h5 class="col" i18n>Notes</h5>
  <button class="btn btn-bidit-submit float-right" (click)="addNote()" i18n>Add Note</button>
</div>

<div *ngFor="let note of notes">
  <div class="card border-bidit-dark bg-light mb-3 shadow">
    <div class="card-body">
      <div class="row">
        <span class="col-8 text-bidit-primary-header">{{_quote.quote_Name}}</span>
        <div class="col-4">
          <div class="float-right">
            <button type="button" class="btn btn-bidit-edit mr-2" (click)="editNote(note)"></button>
            <button type="button" class="btn btn-bidit-delete" (click)="deleteNote(note)"></button>
          </div>
        </div>
      </div>
      <p>
        <span>{{note.quoteNote_Text}}</span>
      </p>
      <div>
        <span class="text-bidit-primary"><span i18n>Created by</span> {{note.createdBy.firstName}} {{note.createdBy.lastName}} on {{note.quoteNote_Created | date: 'M/d/yyyy'}} </span>
      </div>
    </div>
  </div>
</div>

